import CircularProgress from '@mui/material/CircularProgress';

export function RouterSuspenseFallback() {
  return (
    <div
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}
    >
      <CircularProgress size={28} sx={{ color: '#1e2a39' }} />
    </div>
  );
}
